export default __webpack_public_path__ + "static/media/solution_43.4c6e862e.svg";